// Trix toolbar customization
// Applies to every trix-editor instance (informe + plantillas).

function removeToolbarButton(toolbar, attributeName) {
  const button = toolbar.querySelector(`[data-trix-attribute='${attributeName}']`)
  if (button) button.remove()
}

document.addEventListener("trix-initialize", function (event) {
  const toolbar = event.target.toolbarElement
  if (!toolbar) return

  removeToolbarButton(toolbar, "quote")
  removeToolbarButton(toolbar, "code")
})
